import "ngstorage";

import {WALKTHROUGH_STATES, TRIGGER_NEXT_EVENT_NAME, UPDATE_WORKFLOW_EVENT_NAME} from "../../variables";

class OpeningsController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "openings";
    this.walkthroughState = WALKTHROUGH_STATES.OPENINGS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;

    this.API_FIELDS = "subEvents.deduppedJobbles.id,numberOfOpenings";

    this.PostAJobSaveAndExitListener = this.$rootScope.$on("PostAJobSaveAndExit", ($event, params) => {
      this.saveOpenings();
    });

    this.$scope.$on("$destroy", this.PostAJobSaveAndExitListener);

    this.valid_openings = this.validateOpenings();
    this.hasSavedOpenings = false;

  }

  $onInit() {
    this.setLoader();
    this.setOriginalOpenings(this.event.openings);
    this.syncWithApi();
    this.validate();
  }

  setOriginalOpenings(openings) {
    this.originalOpenings = openings;
  }

  validate() {
    this.event.openings = parseInt(this.event.openings);
    this.valid_openings = this.validateOpenings();
    this.$rootScope.$emit(UPDATE_WORKFLOW_EVENT_NAME, {});
  }

  validateOpenings() {
    if (!this.event || !this.event.openings) return false;

    return this.event.openings <= 100 && this.event.openings > 0;
  }

  syncWithApi() {
    this.$events.getEventByIdWithFields(this.event.id, this.API_FIELDS).then((data) => {
      console.log("here we are syncing...");
      console.dir(data);

      this.jobble_id = data.data.subEvents[0].deduppedJobbles[0].id;
      this.event.openings = data.data.numberOfOpenings;
      this.setOriginalOpenings(data.data.numberOfOpenings);
      this.validate();
      this.$timeout(() => {
        this.unSetLoader();
      }, 300);
    });
  }

  saveOpenings() {
    this.$timeout(() => {
      this.savingStep = true;
    });
    return new Promise((resolve) => {
      const delta = this.event.openings - this.originalOpenings;
      this.setOriginalOpenings(this.event.openings);

      if (delta === 0) return resolve(null);

      this.$events.editEventOpenings(this.jobble_id, delta).then((data) => {
        console.log("Saved openings:", data);
        resolve(null);
      });
    });
  }

  goNext() {
    this.setLoader();
    this.saveOpenings().then(() => {
      this.$timeout(() => {
        this.unSetLoader();
        this.savingStep = false;
        this.hasSavedOpenings = true;
        this.goNextNew();
      }, 5000);
    });
  }

  goNextNew() {
    this.$rootScope.$emit(TRIGGER_NEXT_EVENT_NAME, {
      walkthroughState: this.walkthroughState,
    });
    this.$tracking.reportPostAJobSubmitStep("openings");
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }
}

OpeningsController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default OpeningsController;



// WEBPACK FOOTER //
// ./client/app/scenes/postashiftwalkthrough/scenes/openings/openings.controller.js